import {appInstance} from '@/utils/app-accessor'
import {defineStore} from 'pinia'
import type {Ref} from 'vue'

export const useAdminRuntimeStore = defineStore('adminRuntime', () => {
    const notificationTemplates: Ref<any[]> = ref([])
    const notificationTemplatesRecipientType = ref('B2C')

    function SET_NOTIFICATION_TEMPLATES_RECIPIENT_TYPE(type: any) {
        notificationTemplatesRecipientType.value = type
    }

    async function loadNotificationTemplates({localeCode}) {
        const data = await appInstance.$api.notificationTemplates.get({localeCode})
        notificationTemplates.value = data.templates
    }

    return {
        notificationTemplates,
        notificationTemplatesRecipientType,
        SET_NOTIFICATION_TEMPLATES_RECIPIENT_TYPE,
        loadNotificationTemplates,
    }
})

// TODO [P3] Need check this HRM improvement. Relates with https://pinia.vuejs.org/cookbook/hot-module-replacement.html#HMR-Hot-Module-Replacement-
if (import.meta.hot) import.meta.hot.accept(acceptHMRUpdate(useAdminRuntimeStore, import.meta.hot))
